import Vue from 'vue'
import Router from 'vue-router'
import axios from '@/common/axios'
import { parse, compareAsc } from 'date-fns'
import store from '@/store'

// Components
import Home from '@/components/Layouts/Main/Home'
import NotFound from '@/components/Layouts/Main/NotFound'
import Before from '@/components/Layouts/Main/Before'
import Over from '@/components/Layouts/Main/Over'
import Rules from '@/components/Layouts/Main/Rules'

// Program Layouts
import Purchase from '@/components/Layouts/Program/Purchase'

Vue.use(Router)

// Non route compoinent registering
Vue.component('navbar', require('@/components/Partials/Main/Navbar.vue').default)
Vue.component('footer-main', require('@/components/Partials/Main/Footer.vue').default)

// Program non route components
Vue.component('rules-modal', require('@/components/Partials/Modals/RulesModal.vue').default)
Vue.component('rules-text', require('@/components/Rules/RulesText.vue').default)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            name: 'notFound',
            component: NotFound,
            meta: {
                title: 'Not Found',
                partialType: 'meta'
            }
        },
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: 'Share - Tempur-Pedic',
                partialType: 'full'
            }
        },
        {
            path: '/before',
            name: 'before',
            component: Before,
            meta: {
                title: 'Tempur-Pedic',
                partialType: 'meta'
            }
        },
        {
            path: '/over',
            name: 'over',
            component: Over,
            meta: {
                title: 'Tempur-Pedic',
                partialType: 'meta'
            }
        },
        {
            path: '/rules',
            name: 'rules',
            component: Rules,
            meta: {
                title: 'Tempur-Pedic',
                partialType: 'meta'
            }
        },
        {
            path: '/purchase',
            name: 'purchase',
            component: Purchase,
            meta: {
                title: 'Share - Tempur-Pedic',
                partialType: 'full'
            }
        }
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach(async (to, from, next) => {
    // Very first thing we need to do is check the
    // date on the server for our before/over page redirecting.
    try {
        let result = await axios.get('/datetime')
        let serverDate = parse(result.data.message).toISOString()
        await store.dispatch('datetime/setDate', serverDate)

        // Not do check if on /rules or on staging
        if ((to.path !== '/rules') && (window.location.href.indexOf('staging') === -1)) {
            // Only do this when BEFORE_OVER_PAGE_TRIGGER is true
            if (process.env.BEFORE_OVER_PAGE_TRIGGER !== 'off') {
                let beforeCheck = compareAsc(parse(serverDate), parse(process.env.PROGRAM_START_DATE)) // Check for before
                if (beforeCheck === -1 && to.path !== '/before') { next('/before') }
                let overCheck = compareAsc(parse(serverDate), parse(process.env.PROGRAM_END_DATE)) // Check for over
                if (overCheck === 1 && to.path !== '/over') { next('/over') }
            }
        }
    } catch (error) {
        // Uncomment to kick out if api error
        // if (to.path !== '/before') {
        //     next('/before')
        // }
    }

    // Start our vue-progressbar
    router.app.$Progress.start()

    // To set the title of each route
    document.title = to.meta.title

    // Gotta call next()
    next()
})

router.afterEach((to, from) => {
    // End our vue-progressbar
    router.app.$Progress.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js